import React from "react"
import NewGroupForm from "../../components/groups/NewGroupForm"

export default function NewGroup() {
  return <NewGroupForm requireMembers={true} />
}
